import partition from "lodash/partition";
import { APIFieldLatest } from "server/services/tables/types/tables-latest";
import { SUPPORTED_KANBAN_BLOCK_FIELD_TYPES } from "../Block/constants-and-types";

export function filterUnsupportedKanbanFields(
  fields?: APIFieldLatest[]
): Array<Array<APIFieldLatest> | undefined> {
  if (!fields) return [undefined, undefined];

  return partition(fields, (field) =>
    SUPPORTED_KANBAN_BLOCK_FIELD_TYPES.includes(field.type)
  );
}
